import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeOpenPricePercent: (value: Nullable<number>) => void;
}

export const OpenPriceField: React.FC<IProps> = React.memo(({ changeOpenPricePercent }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterOpenPrice') }], [t]);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			changeOpenPricePercent(value);
		},
		[changeOpenPricePercent],
	);

	return (
		<FormInput
			testId="OpenPriceField"
			name="openPricePercent"
			label="openPriceLabel"
			type="number"
			onChangeNumber={handleChange}
			validationRules={validationRules}
			min={0}
			precision={2}
		/>
	);
});
